import styled from 'styled-components';

const StyledColoredTag = styled.div`
  border-radius: ${(props) => props.$radius ?? '9999px'};
  padding: ${(props) => props.$padding ?? '4px 7px'};
  font-weight: 600;
  font-size: ${(props) => props.$fontSize ?? '12px'};
  margin: 0 ${(props) => props.$marginX ?? '10px'};
  display: flex;
  align-items: center;
  border: ${(props)=> props.$border ?? ''};
  width: ${(props) => props.$width ?? 'auto'};
  height: ${(props) => props.$height ?? 'auto'};
  ${(props) => {
    return `
      color: ${props.color || props.theme[props.variant] || props.theme.primary}${props?.theme?.dark && props.variant ? ' 5f' :''};
      background-color: ${props.backgroundColor || props.theme[props.variant] + (props?.theme?.dark && props.variant ? '5f' :'1f') || props.theme.primary + '1f'};
    `;
  }}
`;

export default StyledColoredTag;
